import { Check, Clock, FileText, ListTodo, Plus } from "lucide-react";

export function HomeIllustration({ kind }: { kind: "process" | "tasks" | "history" }) {
  return (
    <div className={`home-illustration home-illustration--${kind}`} aria-hidden="true">
      {kind === "process" ? (
        <>
          <svg className="home-connectors" viewBox="0 0 240 140" fill="none">
            <path d="M62 42H120V110H175M120 42V30H175" stroke="currentColor" strokeWidth="1.5" />
          </svg>
          <div className="home-node home-node--one"><i /><i /></div>
          <div className="home-node home-node--two"><i /><i /></div>
          <div className="home-node home-node--three"><i /><i /></div>
          <span className="home-plus"><Plus size={15} /></span>
        </>
      ) : kind === "tasks" ? (
        <>
          <div className="home-form home-form--back">
            <div className="home-form-heading"><ListTodo size={18} /><i /></div>
            <div className="home-form-field"><i /><span /></div>
            <div className="home-form-field"><i /><span /></div>
          </div>
          <div className="home-form home-form--front">
            <div className="home-form-heading"><ListTodo size={18} /><i /></div>
            <div className="home-form-field"><i /><span /></div>
            <div className="home-form-options">
              <span className="home-form-checkbox"><Check size={10} strokeWidth={2} /></span><i />
              <span className="home-form-checkbox" /><i />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="home-timeline"><i /><i /><i /></div>
          <div className="home-record home-record--one"><Clock size={18} /><div><i /><i /></div></div>
          <div className="home-record home-record--two"><FileText size={18} /><div><i /><i /></div></div>
        </>
      )}
    </div>
  );
}
